import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import ErrorPage from "commonComponents/errorPage/ErrorPage";
import PageHeader from "designV2/components/PageHeader";
import { Skeleton } from "designV2/components/Skeleton";
import EditDriverForm from "./EditDriverForm";
import "superAdminViews/users/superPeople.css";

const GET_DRIVER = gql`
  query getDriverByAdmin($id: ID!) {
    getDriverByAdmin(id: $id) {
      _id
      fullName
      email
      phoneNumber
      gender
      birthDate
      profileImageUrl
      state
      emailVerified
      phoneNumberVerified
      hasNotification
      address {
        full
        zipCode
      }
    }
  }
`;

const EditDriver = (props) => {
  const { loading, error, data } = useQuery(GET_DRIVER, {
    variables: { id: props.match.params.id },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="page superPeoplePage">
        <main className="main">
          <PageHeader title="Edit driver" />
          <Skeleton height={140} />
          <Skeleton height={280} />
        </main>
      </div>
    );
  }

  if (error || !data || !data.getDriverByAdmin) {
    return <ErrorPage />;
  }

  return <EditDriverForm driver={data.getDriverByAdmin} />;
};

export default EditDriver;
